import React from "react";

export default function Loader() {
  return (
    <div className="loader-full-scc">
      <span className="loader"></span>
    </div>
  );
}
